/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { competitionParserCreateGet } from '../fn/competition-parser/competition-parser-create-get';
import { CompetitionParserCreateGet$Params } from '../fn/competition-parser/competition-parser-create-get';
import { competitionParserCreatePost } from '../fn/competition-parser/competition-parser-create-post';
import { CompetitionParserCreatePost$Params } from '../fn/competition-parser/competition-parser-create-post';
import { competitionParserDelete } from '../fn/competition-parser/competition-parser-delete';
import { CompetitionParserDelete$Params } from '../fn/competition-parser/competition-parser-delete';
import { competitionParserGetPollParserAudits } from '../fn/competition-parser/competition-parser-get-poll-parser-audits';
import { CompetitionParserGetPollParserAudits$Params } from '../fn/competition-parser/competition-parser-get-poll-parser-audits';
import { competitionParserGetPollParserFormulaById } from '../fn/competition-parser/competition-parser-get-poll-parser-formula-by-id';
import { CompetitionParserGetPollParserFormulaById$Params } from '../fn/competition-parser/competition-parser-get-poll-parser-formula-by-id';
import { competitionParserGetWithPagination } from '../fn/competition-parser/competition-parser-get-with-pagination';
import { CompetitionParserGetWithPagination$Params } from '../fn/competition-parser/competition-parser-get-with-pagination';
import { competitionParserShowWithPagination } from '../fn/competition-parser/competition-parser-show-with-pagination';
import { CompetitionParserShowWithPagination$Params } from '../fn/competition-parser/competition-parser-show-with-pagination';
import { competitionParserUpdateGet } from '../fn/competition-parser/competition-parser-update-get';
import { CompetitionParserUpdateGet$Params } from '../fn/competition-parser/competition-parser-update-get';
import { competitionParserUpdateIsActive } from '../fn/competition-parser/competition-parser-update-is-active';
import { CompetitionParserUpdateIsActive$Params } from '../fn/competition-parser/competition-parser-update-is-active';
import { competitionParserUpdatePut } from '../fn/competition-parser/competition-parser-update-put';
import { CompetitionParserUpdatePut$Params } from '../fn/competition-parser/competition-parser-update-put';
import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVmMongo } from '../models/custom-result-of-audit-vm-mongo';
import { CustomResultOfGetPollParserByIdDto } from '../models/custom-result-of-get-poll-parser-by-id-dto';
import { CustomResultOfListOfGetPollParserFormulaByIdDto } from '../models/custom-result-of-list-of-get-poll-parser-formula-by-id-dto';
import { CustomResultOfPaginatedListOfGetPollParsersWithPaginationDto } from '../models/custom-result-of-paginated-list-of-get-poll-parsers-with-pagination-dto';

@Injectable({ providedIn: 'root' })
export class CompetitionParserService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `competitionParserCreateGet()` */
  static readonly CompetitionParserCreateGetPath = '/CompetitionParser/Create';

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `competitionParserCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  competitionParserCreateGet$Response(params?: CompetitionParserCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return competitionParserCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * For Authorize.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `competitionParserCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  competitionParserCreateGet(params?: CompetitionParserCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.competitionParserCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `competitionParserCreatePost()` */
  static readonly CompetitionParserCreatePostPath = '/CompetitionParser/Create';

  /**
   * Create Poll Parser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `competitionParserCreatePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  competitionParserCreatePost$Response(params: CompetitionParserCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return competitionParserCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * Create Poll Parser.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `competitionParserCreatePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  competitionParserCreatePost(params: CompetitionParserCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.competitionParserCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `competitionParserUpdateIsActive()` */
  static readonly CompetitionParserUpdateIsActivePath = '/CompetitionParser/UpdateIsActive';

  /**
   * ویرایش فعال بودن.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `competitionParserUpdateIsActive()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  competitionParserUpdateIsActive$Response(params: CompetitionParserUpdateIsActive$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return competitionParserUpdateIsActive(this.http, this.rootUrl, params, context);
  }

  /**
   * ویرایش فعال بودن.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `competitionParserUpdateIsActive$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  competitionParserUpdateIsActive(params: CompetitionParserUpdateIsActive$Params, context?: HttpContext): Observable<CustomResult> {
    return this.competitionParserUpdateIsActive$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `competitionParserUpdateGet()` */
  static readonly CompetitionParserUpdateGetPath = '/CompetitionParser/Update';

  /**
   * Get Poll Parser By Id.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `competitionParserUpdateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  competitionParserUpdateGet$Response(params?: CompetitionParserUpdateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfGetPollParserByIdDto>> {
    return competitionParserUpdateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Poll Parser By Id.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `competitionParserUpdateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  competitionParserUpdateGet(params?: CompetitionParserUpdateGet$Params, context?: HttpContext): Observable<CustomResultOfGetPollParserByIdDto> {
    return this.competitionParserUpdateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfGetPollParserByIdDto>): CustomResultOfGetPollParserByIdDto => r.body)
    );
  }

  /** Path part for operation `competitionParserUpdatePut()` */
  static readonly CompetitionParserUpdatePutPath = '/CompetitionParser/Update';

  /**
   * Update Poll Parser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `competitionParserUpdatePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  competitionParserUpdatePut$Response(params: CompetitionParserUpdatePut$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return competitionParserUpdatePut(this.http, this.rootUrl, params, context);
  }

  /**
   * Update Poll Parser.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `competitionParserUpdatePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  competitionParserUpdatePut(params: CompetitionParserUpdatePut$Params, context?: HttpContext): Observable<CustomResult> {
    return this.competitionParserUpdatePut$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `competitionParserDelete()` */
  static readonly CompetitionParserDeletePath = '/CompetitionParser/Delete';

  /**
   * Delete Poll Parser.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `competitionParserDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  competitionParserDelete$Response(params?: CompetitionParserDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return competitionParserDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete Poll Parser.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `competitionParserDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  competitionParserDelete(params?: CompetitionParserDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.competitionParserDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `competitionParserGetWithPagination()` */
  static readonly CompetitionParserGetWithPaginationPath = '/CompetitionParser/GetWithPagination';

  /**
   * Get Poll Parsers With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `competitionParserGetWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  competitionParserGetWithPagination$Response(params: CompetitionParserGetWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetPollParsersWithPaginationDto>> {
    return competitionParserGetWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Get Poll Parsers With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `competitionParserGetWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  competitionParserGetWithPagination(params: CompetitionParserGetWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetPollParsersWithPaginationDto> {
    return this.competitionParserGetWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetPollParsersWithPaginationDto>): CustomResultOfPaginatedListOfGetPollParsersWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `competitionParserShowWithPagination()` */
  static readonly CompetitionParserShowWithPaginationPath = '/CompetitionParser/ShowWithPagination';

  /**
   * Show Competition Parsers With Pagination.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `competitionParserShowWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  competitionParserShowWithPagination$Response(params: CompetitionParserShowWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfGetPollParsersWithPaginationDto>> {
    return competitionParserShowWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * Show Competition Parsers With Pagination.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `competitionParserShowWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  competitionParserShowWithPagination(params: CompetitionParserShowWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfGetPollParsersWithPaginationDto> {
    return this.competitionParserShowWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfGetPollParsersWithPaginationDto>): CustomResultOfPaginatedListOfGetPollParsersWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `competitionParserGetPollParserAudits()` */
  static readonly CompetitionParserGetPollParserAuditsPath = '/CompetitionParser/GetPollParserAudits';

  /**
   * Only for pishgam user, Get all audit logs.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `competitionParserGetPollParserAudits()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  competitionParserGetPollParserAudits$Response(params: CompetitionParserGetPollParserAudits$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVmMongo>> {
    return competitionParserGetPollParserAudits(this.http, this.rootUrl, params, context);
  }

  /**
   * Only for pishgam user, Get all audit logs.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `competitionParserGetPollParserAudits$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  competitionParserGetPollParserAudits(params: CompetitionParserGetPollParserAudits$Params, context?: HttpContext): Observable<CustomResultOfAuditVmMongo> {
    return this.competitionParserGetPollParserAudits$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVmMongo>): CustomResultOfAuditVmMongo => r.body)
    );
  }

  /** Path part for operation `competitionParserGetPollParserFormulaById()` */
  static readonly CompetitionParserGetPollParserFormulaByIdPath = '/CompetitionParser/GetPollParserFormulaById';

  /**
   * دریافت لیست فرمول ها بر اساس شناسه مسابقه.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `competitionParserGetPollParserFormulaById()` instead.
   *
   * This method doesn't expect any request body.
   */
  competitionParserGetPollParserFormulaById$Response(params?: CompetitionParserGetPollParserFormulaById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfGetPollParserFormulaByIdDto>> {
    return competitionParserGetPollParserFormulaById(this.http, this.rootUrl, params, context);
  }

  /**
   * دریافت لیست فرمول ها بر اساس شناسه مسابقه.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `competitionParserGetPollParserFormulaById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  competitionParserGetPollParserFormulaById(params?: CompetitionParserGetPollParserFormulaById$Params, context?: HttpContext): Observable<CustomResultOfListOfGetPollParserFormulaByIdDto> {
    return this.competitionParserGetPollParserFormulaById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfGetPollParserFormulaByIdDto>): CustomResultOfListOfGetPollParserFormulaByIdDto => r.body)
    );
  }

}
